module.exports = __webpack_public_path__ + "img/xicheji.9af3520d.png";